import { Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, TextField } from "@mui/material";
import { SmtpSettings } from "../../api";
import { PasswordField } from "../controls";

export interface SmtpSettingsControlProps {
  settings?: SmtpSettings;
  onChange: (settings: Partial<SmtpSettings>) => void;
}

export const SmtpSettingsControl = (props: SmtpSettingsControlProps) => {
  const { settings, onChange } = props;

  return (
    <FormControl component="fieldset" sx={{ minWidth: 150 }}>
      <FormLabel component="legend">SMTP settings</FormLabel>
      <FormGroup>
        <TextField label="Host" required variant="standard" value={settings?.host  ?? ""} onChange={(e) => onChange({ host: e.target.value })} />
        <TextField label="Username" variant="standard" value={settings?.username ?? ""} onChange={(e) => onChange({ username: e.target.value })} />
        <PasswordField label="Password" variant="standard" value={settings?.password ?? ""} onChange={(e) => onChange({ password: e.target.value })} />
        <TextField label="Port" variant="standard" type="number" value={settings?.port ?? ""} onChange={(e) => onChange({ port: e.target.value })} />
        <FormControlLabel label="Secure" control={<Checkbox checked={settings?.secure ?? false} onChange={(e, c) => onChange({ secure: c })} />} />
      </FormGroup>
    </FormControl>
  );
};
